module.exports = __webpack_public_path__ + "08714473fa5d9c325a8e3ec98a3cc3a9.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/content/assets/slideshow_02_mobile.jpg
// module id = 653
// module chunks = 0